export { getBasePlacement, getPlacement } from "./get-placement"
export { getPlacementStyles, type GetPlacementStylesOptions } from "./get-styles"
export type {
  AutoUpdateOptions,
  BasePlacement,
  Boundary,
  ComputePositionReturn,
  Placement,
  PositioningOptions,
} from "./types"
